export enum MaritalStatusType {
    CHOOSE = 'E',
    SINGLE = 'S',
    MARRIED = 'C',
    OTHER = 'O',
}